'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _echarts = require('echarts');

var _echarts2 = _interopRequireDefault(_echarts);

var _elementResizeEvent = require('element-resize-event');

var _elementResizeEvent2 = _interopRequireDefault(_elementResizeEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactEcharts = function (_React$Component) {
  _inherits(ReactEcharts, _React$Component);

  function ReactEcharts() {
    _classCallCheck(this, ReactEcharts);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ReactEcharts).apply(this, arguments));
  }

  _createClass(ReactEcharts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var chart = this._renderChart();
      // need to manually resize the chart when the container changes size
      (0, _elementResizeEvent2.default)(this.refs.chart, function () {
        chart.resize();
      });
      var onReady = this.props.onReady;

      if (typeof onReady === 'function') onReady(chart);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._renderChart();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _echarts2.default.dispose(this.refs.chart);
    }
  }, {
    key: '_renderChart',
    value: function _renderChart() {
      var chartDom = this.refs.chart;
      var chart = _echarts2.default.getInstanceByDom(chartDom) || _echarts2.default.init(chartDom);
      var _props = this.props;
      var onClick = _props.onClick;
      var option = _props.option;
      var showLoading = _props.showLoading;

      if (onClick) {
        chart.off('click');
        chart.on('click', onClick);
      }
      chart.setOption(option, this.props.notMerge, this.props.lazyUpdate);
      if (showLoading) {
        chart.showLoading();
      } else {
        chart.hideLoading();
      }
      return chart;
    }
  }, {
    key: 'render',
    value: function render() {
      var height = this.props.height;
      var className = this.props.className;

      return _react2.default.createElement('div', {
        ref: 'chart',
        style: { height: height },
        className: className
      });
    }
  }]);

  return ReactEcharts;
}(_react2.default.Component);



exports.default = ReactEcharts;